/**
 * Home for every Type, Enum and Interface used in more than one place.
 * The `vehicles` domain will be used when refactoring the vehicles tab.
 *
 * TODO: review other types, enums and interfaces not exclusive to local scopes and add here;
 * TODO: consider moving this file to `packages/` or `packages/types/` or `dashboard/`;
 */

export enum DomainTypes {
  VEHICLES = 'VEHICLES',
  EVENTS = 'EVENTS',
  GEOFENCES = 'GEOFENCES',
  GEOFENCE_FORM = 'GEOFENCE_FORM',
}

export type DomainNames = keyof typeof DomainTypes;
